import { css } from 'linaria';

export const gallerySection = css`
  position: relative;
  width: 100%;
  margin-bottom: 80px;

  @media (--only-tablet) {
    margin-bottom: 64px;
  }

  @media (--only-mobile) {
    margin-bottom: 48px;
  }
`;

export const gallerySectionTitle = css`
  @media (--to-desktop) {
    margin-bottom: 16px;
  }

  @media (--only-mobile) {
    font-size: 26px;
    line-height: 32px;
  }
`;

export const swiper = css`
  && {
    .swiper-button-prev {
      &::after {
        background-color: var(--background-primary);
      }
    }

    .swiper-button-next {
      &::after {
        background-color: var(--background-primary);
      }
    }
  }
`;

export const swiperSlideStyle = css`
  && {
    width: 380px;
    height: 280px;
    margin-right: 19px;
    cursor: pointer;

    &:last-of-type {
      margin-right: 0;
    }

    @media (--only-desktop) {
      width: 303px;
      height: 223px;
      margin-right: 16px;
    }

    @media (--only-tablet) {
      width: 250px;
      height: 190px;
      margin-right: 12px;
    }

    @media (--only-mobile) {
      width: 258px;
      height: 190px;
    }
  }
`;

export const galleryImage = css`
  width: 380px;
  height: 280px;
  border-radius: var(--rounding-m);

  @media (--only-desktop) {
    width: 303px;
    height: 223px;
  }

  @media (--only-tablet) {
    width: 250px;
    height: 190px;
  }

  @media (--only-mobile) {
    width: 258px;
    height: 190px;
  }
`;

export const footerButton = css`
  && {
    padding: 10px 22px;
    font-size: 16px;
    line-height: 24px;

    @media (--to-desktop) {
      padding: 8px 36px;
      font-size: 14px;
      line-height: 20px;
    }
  }
`;
